import fb from '../../firebase';

export const FileUploadService = (data) => fb.doUploadFile(data);
export const FileGetService = (data) => fb.doGetFiles(data);
export const FileRemoveService = (data) => fb.doRemoveFile(data);




